import * as React from 'react';
const SvgMessenger = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 17 17" fill="none" {...props}>
        <path
            d="M6.308 9.162a1.25 1.25 0 01-1.361.121L1.078 7.22a.833.833 0 01.113-1.52L15.508.587a.708.708 0 01.905.905L11.3 15.808a.833.833 0 01-1.52.112l-2.063-3.868a1.25 1.25 0 01.12-1.36l4.546-5.784c.153-.193-.099-.445-.292-.291L6.307 9.162h.001z"
            fill="currentColor"
        />
    </svg>
);
export default SvgMessenger;
